export const parseCamelCase = (text: string) => {
  const parse1 = text.replace(/([A-Z])/g, " $1");

  const parse2 = parse1.charAt(0).toUpperCase() + parse1.slice(1);

  return parse2;
};
